import React from "react";
import {
  FaCircleInfo,
  FaMotorcycle,
  FaUserClock,
  FaUserCheck,
} from "react-icons/fa6";
import "./CircleInfo.css";

const CircleInfo = () => {
  return (
    <div className="circle-info-container">
      <FaCircleInfo className="info-icon" />
      <div className="info-tooltip right">
        <h4 style={{ marginTop: 0, marginBottom: "8px", color: "#333" }}>
          🚚 Delivery Map View – User Manual
        </h4>

        <ul style={{ margin: 0, paddingLeft: "18px", lineHeight: "1.6" }}>
          <li>
            The <b>All</b> and <b>Customer</b> tabs display live delivery
            locations. The <b>Agent</b> tab displays check-in and delivery
            locations for the selected employee and date.
          </li>
          <li>
            In the <b>Agent</b> tab, leave both filters empty to view all
            available records; use the clear-filter icon to reset them.
          </li>
          <li>
            Shows <b>Customer locations</b> assigned to the selected Delivery
            Agent using <FaUserClock style={{ color: "orange" }} /> icons.
          </li>
          <li>
            Each <b>Delivery Agent</b> and their assigned <b>Customers</b> are
            shown in the <b>same color</b> to visually group them together.
            <br />
            Example: Agent and customers in{" "}
            <span style={{ color: "#007bff" }}>blue</span> are one team; another
            agent might appear in{" "}
            <span style={{ color: "#f57c00" }}>orange</span>.
          </li>
          <li>
            Select a map marker to view employee, check-in, and delivery
            details.
          </li>
        </ul>

        <div style={{ marginTop: "10px", fontSize: "13px", color: "#555" }}>
          <b>Legend:</b> <br />
          <FaMotorcycle style={{ color: "#007bff" }} /> Agent &nbsp;
          <FaUserClock style={{ color: "orange" }} /> Pending Customer &nbsp;
          <FaUserCheck style={{ color: "green" }} /> Delivered Customer
        </div>
      </div>
    </div>
  );
};

export default CircleInfo;
